export default "__VITE_ASSET__f4163ac6__"